import { useRouter } from "next/router"
import { useEffect } from "react"

const usePageTransitionEffect = (listener: () => void) => {
  const router = useRouter()
  useEffect(() => {
    router.events.on("routeChangeStart", listener)
    window.addEventListener("beforeunload", listener, { once: true })
    return () => {
      router.events.off("routeChangeStart", listener)
      window.removeEventListener("beforeunload", listener)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listener])
}

export default usePageTransitionEffect
